export const catalog = [
  {
    code: "CANNJA-33P-403490A",
    name: "Plastic Plates",
    fullname: "White Plastic w/red imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["CANFCL","CANLST","CANBCL","CANCGR","CANCWE","CANCOX",
      "CANHPO","CANCCL","CANFPA","CANCGE","CANPGR","CANTVI",
      "CANTMO","CANNMO","CANDWE","CANPJA","CANPCC","CANNGR",
      "CANNJA","CANNOX","GREIGR","CANCLR","CANBVI","CANCSE",
      ],
    sizes: {
      5000: 0.0,
    },
  },
  {
    code: "CANNJA-33MRE-400137B",
    name: "Metal Plates",
    fullname: "White Aluminum Plate w/red/blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["CANFCL","CANLST","CANBCL","CANCGR","CANCWE","CANCOX",
      "CANHPO","CANCCL","CANFPA","CANCGE","CANPGR","CANTVI",
      "CANTMO","CANNMO","CANDWE","CANPJA","CANPCC","CANNGR",
      "CANNJA","CANNOX","GREIGR","CANCLR","CANBVI","CANCSE",
      ],
    sizes: {
      5000: 0.0,
    },
  },
  {
    code: "CANNJA-31DD-502545A",
    name: "Die Cut Decals",
    fullname: "Vinyl Diecut Decals (order in quantities of 5000)",
    colors: ["Black", "Red", "Silver", "White"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["CANFCL","CANLST","CANBCL","CANCGR","CANCWE","CANCOX",
      "CANHPO","CANCCL","CANFPA","CANCGE","CANPGR","CANTVI",
      "CANTMO","CANNMO","CANDWE","CANPJA","CANPCC","CANNGR",
      "CANNJA","CANNOX","GREIGR","CANCLR","CANBVI","CANCSE",
      ],
    sizes: {
      500: 0.0,
      1000: 0.0,
      1250: 0.0,
    },
  },
  {
    code: "GP546",
    name: "Deal Jackets",
    fullname: "9 in. x 12 in. Deal Jacket (500/box)",
    colors: [
      "Blue",
      "Buff",
      "Fuchsia",
      "Green",
      "Grey",
      "Lavender",
      "Pink",
      "Salmon",
      "White",
      "Yellow",
    ],
    type: "office",
    default_color: "Buff",
    sizes: {
      500: 0.0,
      1000: 0.0,
    },
  },
  {
    code: "310",
    name: "File Number Labels",
    fullname: "File Right Number Labels (500/box)",
    colors: [
      "Number 0",
      "Number 1",
      "Number 2",
      "Number 3",
      "Number 4",
      "Number 5",
      "Number 6",
      "Number 7",
      "Number 8",
      "Number 9",
    ],
    type: "office",
    default_color: "Number 0",
    sizes: {
      500: 0.017,
    },
  },
  {
    code: "5470",
    name: "A/P Voucher Jacket",
    fullname: "9 in. x 12 in. A/P Voucher Jacket (DSA-540)",
    colors: ["Blue", "Buff", "Green", "Lavender", "Pink", "White"],
    type: "office",
    default_color: "Buff",
    sizes: {
      100: 0.0,
      500: 0.0,
    },
  },
  {
    code: "600088V",
    name: "Seat Covers",
    fullname: "No-Slip Plastic Seat Covers (500/roll)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    sizes: {
      500: 0.147,
    },
  },
  {
    code: "TM1MY394",
    name: "Cuffed Beanie",
    fullname: "Travis Matthew® Solid Cuffed Beanie",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      "One Size Fits Most": 34.56,
    },
  },
  {
    code: "F218",
    name: "Fleece Pullover",
    fullname: 'Port Authority® Value Fleece 1/4" Zip Pullover',
    colors: ["Black", "Gray"],
    type: "mens",
    default_color: "Black",
    sizes: {
      XSmall: 33.19,
      Small: 33.19,
      Medium: 33.19,
      Large: 33.19,
      XLarge: 33.19,
      "2XLarge": 35.33,
      "3XLarge": 39.61,
      "4XLarge": 41.75,
      "5XLarge": 46.03,
      "6XLarge": 48.17,
    },
  },
  {
    code: "K805",
    name: '1/4" Zip Pullover',
    fullname: "Port Authority® Vertical Texture 1/4-Zip Pullover",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      XSmall: 35.87,
      Small: 35.87,
      Medium: 35.87,
      Large: 35.87,
      XLarge: 35.87,
      "2XLarge": 38.23,
      "3XLarge": 42.94,
      "4XLarge": 45.29,
    },
  },
  {
    code: "A430",
    name: "Sport Polo",
    fullname: "Adidas® Men's Basic Sport Polo",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      Small: 38.77,
      Medium: 38.77,
      Large: 38.77,
      XLarge: 38.77,
      "2XLarge": 43.32,
      "3XLarge": 43.32,
      "4XLarge": 42.97,
    },
    type: "mens",
    restricted: true,
  },
  {
    code: "J333",
    name: "Waterproof Jacket",
    fullname: "Port Authority® Torrent Waterproof Jacket",
    colors: ["Black", "Gray"],
    default_color: "Black",
    type: "mens",
    sizes: {
      XSmall: 66.43,
      Small: 66.43,
      Medium: 66.43,
      Large: 66.43,
      XLarge: 66.43,
      "2XLarge": 68.57,
      "3XLarge": 70.71,
      "4XLarge": 74.99,
    },
  },
  {
    code: "J792",
    name: "Nootka Jacket",
    fullname: "Port Authority® Nootka Jacket",
    colors: ["Black"],
    default_color: "Black",
    type: "mens",
    sizes: {
      XSmall: 128.44,
      Small: 128.44,
      Medium: 128.44,
      Large: 128.44,
      XLarge: 128.44,
      "2XLarge": 130.58,
      "3XLarge": 134.86,
      "4XLarge": 72.80,
    },
  },
  {
    code: "MQO00055",
    name: "Soft Shell Jacket",
    fullname: "Clique Telemark Eco Stretch Softshell Jacket",
    colors: ["Black"],
    default_color: "Black",
    type: "mens",
    sizes: {
      Small: 47.08,
      Medium: 47.08,
      Large: 47.08,
      XLarge: 47.08,
      "2XLarge": 49.22,
      "3XLarge": 51.36,
      "4XLarge": 53.50,
      "5XLarge": 55.64,
    },
  },
  {
    code: "BB18002",
    name: "Nailhead Shirt",
    fullname: "Brooks Brothers® Wrinkle-Free Stretch Nailhead Shirt",
    colors: ["White"],
    default_color: "White",
    type: "mens",
    sizes: {
      XSmall: 57.40,
      Small: 57.40,
      Medium: 57.40,
      Large: 57.40,
      XLarge: 57.40,
      "2XLarge": 58.85,
      "3XLarge": 61.74,
      "4XLarge": 63.18,
    },
  },
  {
    code: "TLS608",
    name: "Long Sleeve Shirt",
    fullname: "Port Authority® Tall Long Sleeve Easy Care Shirt",
    colors: ["White"],
    default_color: "White",
    type: "mens",
    sizes: {
      LT: 32.10,
      XLT: 34.24,
      "2XLT": 36.38,
      "3XLT": 38.52,
      "4XLT": 40.66,
    },
  },
  {
    code: "L407",
    name: "Rain Jacket",
    fullname: "Port Authority® Ladies Essential Rain Jacket",
    colors: ["Black", "Graphite"],
    default_color: "Black",
    sizes: {
      XSmall: 56.45,
      Small: 56.45,
      Medium: 56.45,
      Large: 56.45,
      XLarge: 56.45,
      "2XLarge": 58.89,
      "3XLarge": 62.87,
      "4XLarge": 65.01,
    },
    type: "womens",
  },
  {
    code: "L123",
    name: "All Weather Jacket",
    fullname: "Port Authority® Ladies All Weather 3 in 1 Jacket",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      XSmall: 110.72,
      Small: 110.72,
      Medium: 110.72,
      Large: 110.72,
      XLarge: 110.72,
      "2XLarge": 112.86,
      "3XLarge": 117.14,
      "4XLarge": 119.28,
    },
    type: "womens",
  },
  {
    code: "LQO00041",
    name: "Soft Shell Jacket",
    fullname: "Clique Telemark Eco Stretch Softshell Jacket",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      Small: 47.08,
      Medium: 47.08,
      Large: 47.08,
      XLarge: 47.08,
      "2XLarge": 49.22,
      "3XLarge": 51.36,
    },
    type: "womens",
  },
  {
    code: "L233",
    name: "Fleece Full Zip Jacket",
    fullname: "Port Authority® Ladies Summit Fleece Full Zip Jacket",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      XSmall: 46.48,
      Small: 46.48,
      Medium: 46.48,
      Large: 46.48,
      XLarge: 46.48,
      "2XLarge": 48.62,
      "3XLarge": 52.90,
      "4XLarge": 55.04,
    },
    type: "womens",
  },
  {
    code: "LST253",
    name: '1/4" Zip Sweatshirt',
    fullname: "Sport Tek® Ladies 1/4 Zip Sweatshirt",
    colors: ["Black", "Graphite"],
    default_color: "Black",
    sizes: {
      XSmall: 37.62,
      Small: 37.62,
      Medium: 37.62,
      Large: 37.62,
      XLarge: 37.62,
      "2XLarge": 39.76,
      "3XLarge": 44.04,
      "4XLarge": 46.18,
    },
    type: "womens",
  },
  {
    code: "BB18003",
    name: "Nailhead Shirt",
    fullname: "Brooks Brothers® Women's Wrinkle-Free Stretch Nailhead Shirt",
    colors: ["White"],
    default_color: "White",
    sizes: {
      XSmall: 55.28,
      Small: 55.28,
      Medium: 55.28,
      Large: 55.28,
      XLarge: 55.28,
      "2XLarge": 56.67,
      "3XLarge": 59.45,
      "4XLarge": 60.84,
    },
    type: "womens",
  },
  {
    code: "A431",
    name: "Sport Polo",
    fullname: "Adidas® Women's Basic Sport Polo",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      Small: 40.16,
      Medium: 40.16,
      Large: 40.16,
      XLarge: 40.16,
      "2XLarge": 42.97,
      "3XLarge": 42.97,
    },
    type: "womens",
    restricted: true,
  },
  {
    code: "LQO00055",
    name: "Full Zip Vest",
    fullname: "Clique Trail Softshell Full Zip Vest",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      XSmall: 36.38,
      Small: 36.38,
      Medium: 36.38,
      Large: 36.38,
      XLarge: 36.38,
      "2XLarge": 37.45,
      "3XLarge": 38.52,
    },
    type: "womens",
    restricted: false,
  },
  {
    code: "MQO00068",
    name: "Full Zip Vest",
    fullname: "Clique Trail Softshell Full Zip Vest",
    colors: ["Black"],
    default_color: "Black",
    sizes: {
      XSmall: 36.38,
      Small: 36.38,
      Medium: 36.38,
      Large: 36.38,
      XLarge: 36.38,
      "2XLarge": 36.38,
      "3XLarge": 37.45,
      "4XLarge": 38.52,
      "5XLarge": 39.59,
    },
    type: "mens",
    restricted: false,
  },
];
